import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CKEditor from "react-ckeditor-component";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {
  get_email_tempelate_details,
  update_email_tempelate
} from "../../../redux/actions/emailActions";
import loader from "../../../style/loader/loader.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
class UpdateEmailTempelate extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'EDIT_EMAIL_TEMPLATE',
      path: ["Home", "Update Email Tempelate"],
      msgType: "",
      alertMessage: "",
      show: "",
      templateID: "",
      content: "",
      description: "",
      status: "active",
      contentError: "",
      subjectLine:"",
      french_content: "",
      french_description: "",
      french_subjectLine: "",
      french_title: "",
      multi_lang: 'no',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.validate = this.validate.bind(this);
    // this.handleChangeContent = this.handleChangeContent.bind(this);
    // this.editSource = this.editSource.bind(this);
  }

  handleChange(e) {
    if (this.state.msgType !== "" && this.state.alertMessage !== "") {
      this.props.clearAlert();
    }
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChangeContent = (evt) => {
    var newContent = evt.editor.getData();
    this.setState({
      content: newContent
    });
  }

  handleChangeContentFrench = (evt) => {
    var newContent = evt.editor.getData();
    this.setState({
      french_content: newContent
    });
  }

  editSource = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  editSourceFrench = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContentFrench(mode)
        });
    }
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.content.length === 0) {
      isError = true;
      this.setState({ contentError: "red" });
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    this.setState({ show: true });
    if (!err) {
      const addData = {
        content: this.state.content,
        description: this.state.description,
        status: this.state.status,
        templateID: this.state.templateID,
        subjectLine: this.state.subjectLine,
        french_content: this.state.french_content,
        french_description: this.state.french_description,
        french_subjectLine: this.state.french_subjectLine,
        french_title: this.state.french_title,
      };
      this.props.update_email_tempelate(addData);
    }
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    let templateIDParams = this.props.match.params.tempelateID
      ? this.props.match.params.tempelateID
      : "";
    if (templateIDParams !== "") {
      this.props.get_email_tempelate_details(templateIDParams);
    }
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (
      this.props.emailTempelateDetails !== nextProps.emailTempelateDetails &&
      !isEmpty(nextProps.emailTempelateDetails)
    ) {
      this.setState({
        templateID: nextProps.emailTempelateDetails.templateID,
        content: nextProps.emailTempelateDetails.content,
        description: nextProps.emailTempelateDetails.description,
        status: nextProps.emailTempelateDetails.status,
        subjectLine: nextProps.emailTempelateDetails.subjectLine,
        french_content: nextProps.emailTempelateDetails.french_content,
        french_description: nextProps.emailTempelateDetails.french_description,
        french_subjectLine: nextProps.emailTempelateDetails.french_subjectLine,
        french_title: nextProps.emailTempelateDetails.french_title,
      });
    }
    if (
      this.props.updateEmailTempelateResponse !==
      nextProps.updateEmailTempelateResponse
    ) {
      this.props.clearAlert();
      this.handleShow();
      if (nextProps.updateEmailTempelateResponse.message) {
        this.props.renderAlert(
          "success",
          nextProps.updateEmailTempelateResponse.message
        );
      }
      this.props.get_email_tempelate_details(this.state.templateID);
      window.scrollTo(0, 0);
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
      isLoading = false;
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div className="col-lg-12 update-email-tempelate">
        {this.props.receivingEmailTempelateDetails === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.content !== "" && (
          <div>
            <div className="row">
              {this.state.show &&
                this.state.alertMessage !== "" &&
                this.state.msgType && (
                  <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                <BreadcrumbComponent path={this.state.path} />
              </div>
            </div>
            <div className="panel">
              <header className="panel-heading">SMTP Settings</header>
              <div className="panel-body">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <form onSubmit={this.handleSubmit}>
                      <Col md={8} xs={12} mdOffset={2}>
                        <FormGroup controlId="formDescription">
                          <ControlLabel>Subject</ControlLabel>
                          <FormControl
                            componentClass="textarea"
                            value={this.state.subjectLine}
                            name="subjectLine"
                            placeholder="Subject"
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                        {(this.state.multi_lang == "yes") &&
                        <FormGroup controlId="formDescription">
                          <ControlLabel>Subject (Canadian French)</ControlLabel>
                          <FormControl
                            componentClass="textarea"
                            value={this.state.french_subjectLine}
                            name="french_subjectLine"
                            placeholder="Subject"
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                        }
                        <FormGroup controlId="content">
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Content<span>
                              {" "}
                              (Don't change text which has $ symbol)
                            </span>
                          </ControlLabel>
                        </FormGroup>
                        <CKEditor
                          activeClass="p10"
                          content={this.state.content}
                          events={{
                            change: this.handleChangeContent,
                            blur: this.handleChangeContent,
                            afterPaste: this.handleChangeContent,
                            mode: this.editSource
                          }}
                        config={{allowedContent: true}}
                        />
                        {(this.state.multi_lang == "yes") &&
                        <FormGroup controlId="frcontent">
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Content (Canadian French)<span>
                              {" "}
                              (Don't change text which has $ symbol)
                            </span>
                          </ControlLabel>
                        </FormGroup>
                        }
                        {(this.state.multi_lang == "yes") &&
                        <CKEditor
                          activeClass="p10"
                          content={this.state.french_content}
                          events={{
                            change: this.handleChangeContentFrench,
                            blur: this.handleChangeContentFrench,
                            afterPaste: this.handleChangeContentFrench,
                            mode: this.editSourceFrench
                          }}
                        config={{allowedContent: true}}
                        />
                        }
                        <FormGroup controlId="formDescription">
                          <ControlLabel>Description</ControlLabel>
                          <FormControl
                            componentClass="textarea"
                            value={this.state.description}
                            name="description"
                            placeholder="Description"
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                        {(this.state.multi_lang == "yes") &&
                        <FormGroup controlId="formFrenchDescription">
                          <ControlLabel>Description (Canadian French)</ControlLabel>
                          <FormControl
                            componentClass="textarea"
                            value={this.state.french_description}
                            name="french_description"
                            placeholder="Description"
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                        }
                        <FormGroup controlId="formStatus">
                          <ControlLabel>Status</ControlLabel>
                          <FormControl
                            componentClass="select"
                            name="status"
                            onChange={this.handleChange}
                            value={this.state.status}
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                      <Row className="BtnRow">
                        <Col md={12} xs={12}>
                          <Button
                            bsStyle="info"
                            type="submit"
                            id="save-button"
                            disabled={this.props.updating}
                          >
                            Save
                          </Button>
                          <Button
                            bsStyle="default"
                            onClick={() => this.context.router.history.push(`/emailTemplate`)}
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

UpdateEmailTempelate.propTypes = {
  get_email_tempelate_details: PropTypes.func.isRequired,
  // add_smtp: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  updatingEmailTempelateDetails:
    state.emailReducer.updatingEmailTempelateDetails,
  updateEmailTempelateResponse: state.emailReducer.updateEmailTempelateResponse,
  emailTempelateDetails: state.emailReducer.emailTempelateDetails,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.emailReducer.error,
  receivingEmailTempelateDetails:
    state.emailReducer.receivingEmailTempelateDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    update_email_tempelate,
    get_email_tempelate_details,
    clearAlert,
    renderAlert
  })
)(UpdateEmailTempelate);



// WEBPACK FOOTER //
// ./src/app/views/admin/emailTempelate/updateEmailTempelate.js